import ProgressBar from 'react-bootstrap/ProgressBar';
import * as HELPER from './../../../config/helper';
function ProgressBarLabel(props) {
  let { total_amount, paid_amount  } = props.amount
  // FOR TOTAL PAYOUT %AGE 
  const now =  paid_amount ? (((paid_amount)/(total_amount)) * 100) : 0;
  return <ProgressBar now={now} label={`${HELPER.addCurrencyFormatting(paid_amount)}`} visuallyHidden/>;
}

export default ProgressBarLabel